// src/routes/currenciesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Currencies from '../pages/currencies/Currencies';
import CreateCurrency from '../pages/currencies/CreateCurrency';
import EditCurrency from '../pages/currencies/EditCurrency';
import ProtectedRoute from '../components/global/ProtectedRoute';


const currenciesRoutes = (
    <>
        {/* Currencies List */}
        <Route
            path="/currencies"
            element={
                <ProtectedRoute requiredPermission="currencies_list">
                    <Currencies />
                </ProtectedRoute>
            }
        />


        {/* Currencies Archive */}
        <Route
            path="/currencies/archive"
            element={
                <ProtectedRoute requiredPermission="currencies_archive_list">
                    <Currencies />
                </ProtectedRoute>
            }
        />


        {/* Create Currency */}
        <Route
            path="/currencies/create"
            element={
                <ProtectedRoute requiredPermission="currencies_create">
                    <CreateCurrency />
                </ProtectedRoute>
            }
        />


        {/* Edit Currency */}
        <Route
            path="/currencies/:id/edit"
            element={
                <ProtectedRoute requiredPermission="currencies_edit">
                    <EditCurrency />
                </ProtectedRoute>
            }
        />
    </>
);


export default currenciesRoutes;
